import React, { useState, useRef, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import logo from "../../../../images/SBM.svg";
import { HiMenu, HiX, HiChevronDown } from "react-icons/hi";
import "../LandingPageCss/MainHome.css";

export default function Navbar() {
  const [openMenu, setOpenMenu] = useState(false);
  const [showDesktopFeatures, setShowDesktopFeatures] = useState(false);
  const [showMobileFeatures, setShowMobileFeatures] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const featureItems = [
    {
      name: "WhatsApp Campaign",
      desc: "Grow faster with smart automation",
      icon: "🚀",
      path: "/whatsApp_campaign",
    },
    {
      name: "Personalized Messaging",
      desc: "Build stronger customer connections",
      icon: "🤝",
      path: "/personalized_messaging",
    },
    {
      name: "Automated Replies",
      desc: "Smarter conversations with AI flows",
      icon: "⚡",
      path: "/automated_replies",
    },
    {
      name: "Audience Targeting",
      desc: "Reach the right customers instantly",
      icon: "🎯",
      path: "/audience_targeting",
    },
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDesktopFeatures(false);
      }
    };

    if (showDesktopFeatures) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDesktopFeatures]);

  return (
    <nav
      className=" w-100 py-3"
      style={{ top: "20px", zIndex: 1000, overflow: "visible" }}
    >
      <div className="container" style={{ overflow: "visible" }}>
        <div
          className="bg-white rounded-pill shadow-sm px-4 py-2 d-flex align-items-center justify-content-between"
          style={{ overflow: "visible" }}
        >
          <Link className="navbar-brand mb-0" to="/">
            <img src={logo} alt="Logo" style={{ height: "50px" }} />
          </Link>

          <ul className="navbar-nav d-none d-lg-flex flex-row gap-4 mb-0">
            <li className="nav-item">
              <Link className="nav-link fw-semibold" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link fw-semibold" to="/about">
                About Us
              </Link>
            </li>

            {/* Desktop Features Dropdown */}
            <li
              className="nav-item features-dropdown-container"
              ref={dropdownRef}
            >
              <span
                className="nav-link fw-semibold d-flex align-items-center gap-1"
                style={{ cursor: "pointer" }}
                onClick={() => setShowDesktopFeatures(!showDesktopFeatures)}
              >
                Features{" "}
                <HiChevronDown
                  className={`chevron-icon ${
                    showDesktopFeatures ? "rotated" : ""
                  }`}
                  size={18}
                />
              </span>

              {showDesktopFeatures && (
                <div className="features-dropdown-menu">
                  <h6 className="text-muted mb-3 px-2">Platform Solutions</h6>
                  <div className="d-flex flex-column gap-2">
                    {featureItems.map((item, idx) => (
                      <div
                        key={idx}
                        className="feature-item"
                        onClick={() => {
                          navigate(item.path);
                          setShowDesktopFeatures(false);
                        }}
                      >
                        <span className="feature-icon">{item.icon}</span>
                        <div className="feature-content">
                          <h6>{item.name}</h6>
                          <p>{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </li>

            <li className="nav-item">
              <Link className="nav-link fw-semibold" to="/pricing_details">
                Pricing
              </Link>
            </li>
          </ul>

          <div className="d-none d-lg-block">
            <button
              onClick={() => navigate("/login")}
              className="btn bg-yellowgreen rounded-pill px-4 py-2 fw-bold"
            >
              Login
            </button>
          </div>

          <button
            className="btn d-lg-none p-0"
            onClick={() => setOpenMenu(true)}
          >
            <HiMenu size={28} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {openMenu && (
        <>
          <div
            className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
            style={{ zIndex: 1040 }}
            onClick={() => setOpenMenu(false)}
          />
          <div
            className="position-fixed top-0 end-0 bg-white h-100 shadow-lg"
            style={{ width: "280px", zIndex: 1050, overflowY: "auto" }}
          >
            <div className="d-flex justify-content-end p-3">
              <button className="btn" onClick={() => setOpenMenu(false)}>
                <HiX size={28} />
              </button>
            </div>

            <ul className="list-unstyled px-4">
              <li className="mb-3">
                <Link
                  className="text-decoration-none text-dark fw-semibold"
                  to="/"
                  onClick={() => setOpenMenu(false)}
                >
                  Home
                </Link>
              </li>
              <li className="mb-3">
                <Link
                  className="text-decoration-none text-dark fw-semibold"
                  to="/about"
                  onClick={() => setOpenMenu(false)}
                >
                  About
                </Link>
              </li>

              {/* Mobile Features Dropdown */}
              <li className="mb-3">
                <div
                  className="d-flex align-items-center justify-content-between"
                  onClick={() => setShowMobileFeatures(!showMobileFeatures)}
                  style={{ cursor: "pointer" }}
                >
                  <span className="text-dark fw-semibold">Features</span>
                  <HiChevronDown
                    className={`chevron-icon ${
                      showMobileFeatures ? "rotated" : ""
                    }`}
                    size={18}
                  />
                </div>

                {showMobileFeatures && (
                  <div className="mobile-features-dropdown">
                    {featureItems.map((item, idx) => (
                      <div
                        key={idx}
                        className="mobile-feature-item"
                        onClick={() => {
                          navigate(item.path);
                          setOpenMenu(false);
                          setShowMobileFeatures(false);
                        }}
                      >
                        {item.name}
                      </div>
                    ))}
                  </div>
                )}
              </li>

              <li className="mb-3">
                <Link
                  className="text-decoration-none text-dark fw-semibold"
                  to="/pricing_details"
                  onClick={() => setOpenMenu(false)}
                >
                  Pricing
                </Link>
              </li>

              <li className="mt-4">
                <button
                  onClick={() => {
                    navigate("/login");
                    setOpenMenu(false);
                  }}
                  className="btn bg-yellowgreen w-100 rounded-pill py-2 fw-bold"
                >
                  Login
                </button>
              </li>
            </ul>
          </div>
        </>
      )}
    </nav>
  );
}
